<template>
    <a
        class="search-tip"
        :class="{
            'search-tip--game': tip.externalSystemId,
            'search-tip--selected': isSelected,
            'game-launcher': tip.externalSystemId,
        }"
        :href="tipUrl ?? undefined"
        :data-game-id="tip.externalSystemId || undefined"
        :data-a-gametype="tip.type"
        @click="handleClick"
    >
        <DsButton type="primary" size="sm" v-if="buttonLabel" class="search-tip__btn">
            {{ buttonLabel }}
        </DsButton>
        <WebpImage v-if="tip.imageUrl" :src="tip.imageUrl" alt="" width="32" height="32" class="search-tip__img" />
        <span class="search-tip__name">
            <span class="search-tip__category" v-html="tip.category"></span>
            <template v-if="tip.title">
                <span class="search-tip__slash"> / </span>
                <span class="search-tip__title" v-html="tip.title"></span>
            </template>
        </span>
    </a>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { useQuickSearch } from "../composables/use-quick-search";
import { QuickSearchTipModel } from "../models/quick-search-models";

const props = withDefaults(
    defineProps<{
        tip: QuickSearchTipModel;
        isSelected?: boolean;
    }>(),
    {
        isSelected: false,
    }
);

const { getTipUrl, getTipButtonLabel, onTipClick } = useQuickSearch();

const tipUrl = computed(() => getTipUrl(props.tip));
const buttonLabel = computed(() => getTipButtonLabel(props.tip));

function handleClick(event: MouseEvent) {
    onTipClick(props.tip);

    if (props.tip.externalSystemId) {
        event.preventDefault();
    }
}
</script>
